<template>
  <div id="pdf" style="top: 0px;left: 0px;right: 0px;bottom: 0px;background-color: white;font-size: 14px;font-family: sans-serif;overflow:scroll;">
    <div class="paper" style="width: 720px;margin: auto;">
      <table id="p-table" class="table w-full text-left whitespace-no-wrap">
        <thead class="bg-gray-200">
          <tr class="text-left">
            <th class="border p-2">Order ID</th>
            <th class="border p-2">Warehouse</th>
            <th v-if="currentUser.type!='Seller'" class="border p-1 text-center ">Seller</th>
            <th class="border p-2 text-center">Customer</th>
            <th class="border p-2 text-center">Phone</th>
            <th class="border p-2 text-center">Products</th>
            <th class="border p-2 text-center">Address</th>
            <th class="border p-2 text-center">TotalPrice</th>
            <th class="border p-2 text-center">Order date</th>
            <th class="border p-2 text-center">Status</th>
            <th class="border p-2 text-center">Reason</th>
            <th v-if="currentUser.type!='Seller'" class="border p-2 text-center">teleConsultant</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="items.length == 0" >
            <th class="border p-3 bg-gray-100" colspan="10">
              No order found
            </th>
          </tr>
          <tr class="text-center" v-for="(item, index) in items" :key="index" :class="index % 2 == 0 ? 'bg-gray-100' : ''">
            <td class="border p-2">
              <span class="flex items-center">
                {{ $f.getIdbySplit(item.id.replace('#',''))  }}
              </span>
            </td>
            <td  class="border p-2">
              <span class="flex items-center">
                {{ idWharhouse.name }}
              </span>
            </td>
            <td v-if="currentUser.type!='Seller'" class="border p-2">
              <span class="flex items-center">
                {{ item.seller && item.seller.fullName ? item.seller.fullName.replace(/[^a-zA-Z 0-9]+/g,'') : "" }}
              </span>
            </td>
            <td class="border p-2"> 
              <span class="flex items-center">
                {{ item.customer && item.customer.fullName ? item.customer.fullName : "" }}
              </span>
            </td>
             <td class="border p-2">
              <span class="flex items-center">
                {{ item.customer && item.customer.phone ? item.customer.phone : "" }}
              </span>
            </td>
            <td class="border p-2  bg-green-100">
              {{ sumProduct(item.details) }}
            </td>
             <td class="border p-2  bg-green-100">
              {{ item.customer && item.customer.address ? item.customer.address.replace(/[^a-zA-Z 0-9]+/g,'') : "" }}
            </td>
             <td class="border p-2  bg-green-100">
              {{ item.totalPrice }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ $moment(item.date).format('DD-MM-YYYY') }}
            </td>
            <td class="border p-2  bg-green-100">
              {{ item.status.name }}
            </td>
             <td class="border p-2  bg-green-100">
              {{ item.comment?item.comment:"" }}
            </td>
            <td v-if="currentUser.type!='Seller'" class="border p-2  bg-green-100">
              {{  item.status.name === 'Confirmed' ? item.teleConsultant && item.teleConsultant.fullName ? item.teleConsultant.fullName.replace(/[^a-zA-Z 0-9]+/g,'') : "System|Admin" : "" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    currentUser: { type: Object},
    idWharhouse: { type: Object}
  },
  mounted() {
    // const pdf = document.querySelector("#pdf").cloneNode(true);
    // document.querySelector("#app").before(pdf);
    // document.querySelector("#app").style.display = "none";
    // window.print();
    // pdf.remove();
    // document.querySelector("#app").style.display = "block";
    // this.exportToExcel()
    // this.$emit("printed");
    //console.log('items excel____',this.items)
  },
  methods: {
    // getRestDays(endDate) {
    //   return this.$options.filters.toDays(endDate, Date.now());
    // },
    sumQteProduct(data){
      let sum=0;
      for (let i in data) {
        sum=sum+data[i].quantity;
      }
      return sum;
    },
    sumProduct(data){
      let product="";
      for (let i in data) {
        if(data[i].product && data[i].product.name) product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
  }
};
</script>
<style>
table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}
thead {
  display: table-header-group;
}
tfoot {
  display: table-footer-group;
}
</style>
